

















import { defineComponent, PropType } from '@vue/composition-api';
import { Spacing } from '@front-app/components/constants';
import SimpleCard from '../SimpleCard.vue';
import StandardErrorText from './StandardErrorText.vue';

export default defineComponent({
	components: {
		SimpleCard,
		StandardErrorText,
	},
	props: {
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.REGULAR,
		},
		suggestRefresh: Boolean,
	},
	setup() {
		return {
			Spacing,
		};
	},
});
